/**
 * Guest-realm source for the Calendar extension. Calendar is host-rendered
 * (CalendarView.js, full-bleed — no sidebar) and talks to the
 * extension_records_* Tauri commands directly. This entry script is a no-op kept only to satisfy
 * the extension registration contract (ftp/entry.js precedent).
 */
export const calendarEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
